<template>
  <div>{{ group }}</div>
</template>

<script>
import { get } from 'lodash';
import { splitByComma } from 'utils';
import NuttremaTable from 'components/ui/table/nuttrema-table';
import NuttremaTableColumn from 'components/ui/table/nuttrema-table-column';

import ReturnQuery from 'components/mixins/return-query';

export default {
  name: 'nuttrema-index-list-item',
  mixins: [ReturnQuery],
  components: {
    NuttremaTable,
    NuttremaTableColumn,
  },
  props: {
    group: {
      required: true,
      default: null,
    },
    title: {
      required: false,
      default: null,
    },
    meta: {
      required: false,
      default: null,
    },
    edit: {
      required: false,
      default: true,
    },
    params: {
      required: false,
      default: null,
    },
    permissions: {
      required: false,
      default: null,
    },
  },
  methods: {
    splitByComma,
    gotoDetailsPage(id) {
      this.$router.push({ name: get(this.meta, 'navigation.edit'), params: { id }, query: { returnTo: this.returnTo } });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  @import "~styles/component/nuttrema-list-item";

  .nuttrema-list-item-custom {
    display: flex;
    align-self: stretch;
    flex-direction: column;
    flex-shrink: 0;

    .nuttrema-list-item__group {
      display: flex;
      align-self: stretch;
      padding: 1em 0.85em 0.25em 0.85em;
      border-bottom: 1px solid $table-border-color;
      > span {
        font-size: 1rem;
        font-weight: 500;
      }
    }

    .nuttrema-list-item__table {
      display: flex;
      align-self: stretch;
      flex-direction: column;
    }

    .nuttrema-list-item__note {
      display: flex;
      font-size: 0.9em;
      align-self: stretch;
      margin: 0.75em 1.25em;
      flex-direction: column;

      text-align: right;

      .note__title {
        font-weight: 500;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/list/nuttrema-index-list-item.vue